/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import DropDown from './drop-down';

export default class TopMenu extends DropDown {
  init() {
    let elmId;
    let self = this;
    this.el.find('li').hover((e) => {
      if (this.el.parent().hasClass('mobile')) {
        return;
      }
      if (elmId !== $(e.currentTarget).attr('id')) {
        if ($(e.target).data('depth') === 0) {
          $(`#${elmId} .js-sub-menu`).hide();
        }
        elmId = $(e.currentTarget).attr('id');
      }
      if (elmId && $(e.target).data('depth') === 0) {
        $(`#${elmId} .js-sub-menu`).show();
      }
    });
    $('.menu-icon').on('click', function() {
      document.getElementById("mobile_top_menu_wrapper").style.width = "300px";
      document.getElementById("menuCanvas").style.width = "100%";
      document.getElementById("menuCanvas").style.opacity = "0.8";
      self.toggleMobileMenu();
    });
    $('.tdclose').on('click', function() {
      document.getElementById("mobile_top_menu_wrapper").style.width = "0px";
      $('#menuCanvas').removeAttr('style');
    });
    $('.js-top-menu').mouseleave(() => {
      if (this.el.parent().hasClass('mobile')) {
        return;
      }
      $(`#${elmId} .js-sub-menu`).hide();
    });
    this.el.on('click', (e) => {
      if (this.el.parent().hasClass('mobile')) {
        return;
      }
      e.stopPropagation();
    });
    prestashop.on('responsive update', function(event) {
      $('.js-sub-menu').removeAttr('style');
      self.toggleMobileMenu();
    });
    super.init();
  }

  toggleMobileMenu() {
      if ($('#mobile_top_menu_wrapper').is(":visible")) {
      } else {
      }
  }
}


function topNavbar(){$("#top-menu > li > .sub-menu > ul.top-menu").each(function(){var a=$(this).children("li").length,b=0;$(this).children("li").each(function(c,d){b=a}),b<1?$(this).parent().addClass("onecolumn"):b%3===0||b>3?$(this).parent().addClass("threecolumn"):b%2===0&&$(this).parent().addClass("twocolumn")});var a=$("#_desktop_top_menu"),b=$(a).find("#top-menu > li");b.hover(function(){$(document).width()<=991?$("#_desktop_top_menu .sub-menu").removeAttr("style"):$(document).width()>=992&&($("body").hasClass("lang-rtl")?$("#_desktop_top_menu .sub-menu").each(function(){var a=$("#_desktop_top_menu").offset(),b=$(this).parent().offset(),c=$(this).parent().outerWidth(),d=$(window).width(),e=d-(a.left+$("#_desktop_top_menu").outerWidth()),f=d-(b.left+c),g=f+$(this).outerWidth()-(e+$("#_desktop_top_menu").outerWidth());g>0&&$(this).css("margin-right","-"+g+"px")}):$("#_desktop_top_menu .sub-menu").each(function(){var a=$("#_desktop_top_menu").offset(),b=$(this).parent().offset(),c=b.left+$(this).outerWidth()-(a.left+$("#_desktop_top_menu").outerWidth());c>0&&$(this).css("margin-left","-"+c+"px")}))})}$(document).ready(function(){topNavbar()}),$(window).resize(function(){topNavbar()});


// WEBPACK FOOTER //
// ./js/components/top-menu.js